module.exports = __webpack_public_path__ + "img/State=15.5441445d.svg";